import script from "./MyDemands.vue?vue&type=script&setup=true&lang=js"
export * from "./MyDemands.vue?vue&type=script&setup=true&lang=js"

import "./MyDemands.vue?vue&type=style&index=0&id=531716de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531716de"]])

export default __exports__